import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/outdoor/u7-outdoor.png";
import type { Product } from "../../types";
import { wifiOutdoor } from "../product-list-groups/wifiOutdoor";
import {
  antennaType,
  connectedDevices,
  extendedRangeMode6Ghz,
  externalAntennaSupport,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const u7outdoor: Product = {
  id: "u7outdoor",
  productTitle: "U7 Outdoor",
  isNew: true,
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/u7-outdoor`,
  ],
  storePathParts: {
    productSlug: "u7-outdoor",
    category: UniFiChildCategorySlug.WiFiOutdoor,
  },
  sku: "U7-Outdoor",
  description: "u7outdoor.description",
  productListGroup: wifiOutdoor,
  image: { src: image, width: 200, height: 160 },
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '170 x 208 x 54.5 mm\n(6.7 x 8.2 x 2.1")',
      },
    },
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7outdoor.wifiTechnology",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: extendedRangeMode6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: antennaType.id,
      value: {
        type: "translation",
        value: "u7outdoor.antennaType.1",
        asterisk: 1,
      },
    },
    {
      propertyId: wifiCoverage.id,
      value: {
        type: "translation",
        value: "u7outdoor.wifiCoverage",
      },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "250+" },
    },
    {
      propertyId: externalAntennaSupport.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u7outdoor.uplink" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.wallPole",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "string", value: "IPX6" },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u7outdoor.notes.antennaType"],
};
